<template>
  <oms-filter-content :title='title' :is-filtering='modelValue?.include?.length > 0 || modelValue?.exclude?.length'>
    <span v-for='item in modelValue?.include' class='badge badge-info position-static mr-1'>
      {{ item.name }}
    </span>

    <strong v-if='modelValue?.exclude?.length > 0' class='mx-1'>{{ t('features.vue.shared.filters.excluding') }}</strong>

    <span v-for='item in modelValue?.exclude' class='badge badge-info position-static mr-1'>
      {{ item.name }}
    </span>
  </oms-filter-content>
</template>

<script>

import OmsFilterContent from '../filter-content.vue'

export default {
  inject: ['i18n'],

  props: {
    title: { type: String, required: true },
    modelValue: Object
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    }
  },

  components: {
    OmsFilterContent
  }
}
</script>
